import { useQuery, UseQueryResult } from "react-query";
import axios from "axios";
import Config from "../config/auth.json";
import { AdditionalConfig } from "../utils/consts";
import { useOktaAuth } from "@okta/okta-react";

export type Contract = {
  key: string;
  name: string;
};

const fetchContracts = async (customerName: string): Promise<Contract[]> => {
  const token = JSON.parse(window.localStorage.getItem("okta-token-storage") || "{}")?.accessToken?.accessToken;
  try {
    const response = await axios.get(
      `${Config.endpoint}contractsservice/customers/${encodeURIComponent(customerName)}/contracts`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data ?? [];
  } catch (error) {
    console.error(`Error fetching contracts for ${customerName}:`, error);
    return [];
  }
};

export const useGetContracts = (customerName: string | null): UseQueryResult<Contract[]> => {
  const { authState } = useOktaAuth();
  const token = authState?.accessToken?.accessToken;
  return useQuery(
    ["contracts", customerName],
    () => fetchContracts(customerName!),
    {
      enabled: !!token && !!customerName,
      ...AdditionalConfig,
    },
  );
};
